define('modules/profiles/models/salesforce.identity.details.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function (_, Backbone, BaseModel) {
    var SalesforceIdentityModel = BaseModel.extend({
        base: 'salesforce/identity'
    });
    return SalesforceIdentityModel;
});

